import './index.scss';

import React from 'react';

import OffersSwipeCrown from '../offers-swipe-crown';

import LockImage from '../../../assets/images/lock.svg';
import CrownWhiteImage from '../../../assets/images/offers/crown-white.svg';
import CloseImage from '../../../assets/images/x-circle.svg';
import { getCategoryImage } from '../../utils/services';

const OffeBurnTheCrownModal = props => {
  const { burnOnClick, closeOnClick, data, userAvailablePoints, theme } = props;
  const { crowns_to_burn, title, image_url, description, product, name } = data;
  let imageUrl =
    product && product[0]
      ? getCategoryImage(product[0]?.image_urls, 'offer')
      : image_url;
  return (
    <div className="offer-burn-crown_wrapper">
      <div className="offer-burn-crown">
        <div className="offer-burn-crown__card_wrapper">
          <div className="offer-burn-crown__card">
            <div className="offer-burn-crown__image">
              {imageUrl && imageUrl['1x'] ? (
                <picture>
                  <source
                    srcSet={`${imageUrl['1x']}, ${imageUrl['2x']} 2x, ${imageUrl['3x']} 3x`}
                    type="image/jpeg/png"
                  />
                  <img
                    src={`${imageUrl['2x']}`}
                    alt={title}
                    className="offer-burn-crown__img"
                  />
                </picture>
              ) : (
                <img
                  src={image_url}
                  alt={title}
                  className="offer-burn-crown__img"
                />
              )}
            </div>
            <div className="offer-burn-crown__detail">
              <p className="offer-burn-crown__title">{title}</p>
              <p className="offer-burn-crown__description">{description}</p>
              <p className="offer-burn-crown__res-des">
                If you’re at the restaurant, now would be a good time to redeem
                this offer ;)
              </p>
            </div>
          </div>

          {userAvailablePoints >= crowns_to_burn ? (
            <OffersSwipeCrown
              value={crowns_to_burn}
              onClick={burnOnClick}
              theme={theme}
            />
          ) : (
            <div className="offer-burn-crown__unlock">
              <div className="offer-burn-crown__unlock-crown">
                <img src={CrownWhiteImage} alt="crown" />
                <p className="offer-burn-crown__unlock-text">
                  {crowns_to_burn}
                </p>
              </div>
              <div className="offer-burn-crown__unlock-not-enough">
                <img src={LockImage} alt="lock" />
                <p className="offer-burn-crown__unlock-text">
                  Not Enough BK Crowns
                </p>
              </div>
            </div>
          )}
        </div>

        <div
          role="presentation"
          onClick={() => closeOnClick()}
          className="u_display_only_mob offer-burn-crown__close u_cursor_pointer"
        >
          <img src={CloseImage} alt="close" />
        </div>
      </div>
    </div>
  );
};

export default OffeBurnTheCrownModal;
